<template>
	<div>
		<TheAsStampDescription />
		<AsStampHistoryStatus />
	</div>
</template>

<script>
import TheAsStampDescription from './TheAsStampDescription';
import AsStampHistoryStatus from './AsStampHistoryStatus';

export default {
	components: {
		TheAsStampDescription,
		AsStampHistoryStatus,
	},
};
</script>

<style scoped></style>
